/**
 * The content column a page shares between its header and its body. Pass the
 * same value to `PageHeader` and `PageBody` so the title, actions, tabs,
 * filter bar, and content all line up — the header chrome itself stays full
 * bleed regardless.
 */
export const PageWidth = {
  /** Settings forms. */
  Form: "form",
  /** The common case: detail pages, entity tables, most content. */
  Standard: "standard",
  /** Dense layouts that need the extra room. */
  Wide: "wide",
  /** No content column; content spans the page gutter to gutter. */
  Full: "full",
} as const;

export type PageWidth = (typeof PageWidth)[keyof typeof PageWidth];

/** Centers content in its column. `Full` contributes nothing. */
export const pageWidthClassNames: Record<PageWidth, string> = {
  [PageWidth.Form]: "mx-auto w-full max-w-2xl",
  [PageWidth.Standard]: "mx-auto w-full max-w-4xl",
  [PageWidth.Wide]: "mx-auto w-full max-w-6xl",
  [PageWidth.Full]: "",
};
